import React from 'react'
import moment from 'moment'
import 'moment/locale/pt-br'

import './styles.css'

export default ({date, comment, answerDate, answer}) => {
    return(
        <div>
            {
                comment ?
                    <div id='card-comentario-resposta'className='modal-content-card' >
                        <p className = 'modal-content-date'>{moment(date).format('L')}</p>
                        <p id='comentario'className='modal-content-comment'> {comment}</p> 
                        {
                            answer!=='ntem' ?   
                            <div className='modal-content-answer-style'>

                                <div className='modal-answer-date'>
                                    <p className='modal-content-answer-title'>Resposta do estabelecimento:</p>
                                    <p className = 'modal-content-date'> {moment(answer.date).format('L')}</p>
                                </div>
                                                
                                <p id='resposta'className='modal-content-answer'>{answer.answer}</p> 
                            </div>              
                            :
                            null
                            // console.log('n tem msm')
                        }
                    </div> 
                    :
                     null
            }
        </div>
    )
}